import { Button, Col, Modal, Row } from "antd";
import React from "react";
import { useSelector } from "react-redux";

function ApproveDesignationModal(props) {
  const positionState = useSelector((state) => state.positionState.value);

  return (
    <Modal
      title={"Approve designation"}
      visible={props.visible}
      onOk={props.handleOk}
      onCancel={props.handleCancel}
      footer={null}
    >
      <Row>
        <Col span={12} className="mb-6">
          <div className="text-xs">Name</div>
          <div>{props.data?.data?.name}</div>
        </Col>
        <Col span={12} className="mb-6">
          <div className="text-xs">Abbreviation</div>
          <div>{props.data?.data?.abbreviation}</div>
        </Col>
        <Col span={12} className="mb-6">
          <div className="text-xs">Status</div>
          <div>{props.data?.data?.status}</div>
        </Col>
        <Col span={12} className="mb-6">
          <div className="text-xs">Added On</div>
          <div>{props.data?.data?.createdOn?.slice(0, 10)}</div>
        </Col>
      </Row>
      {positionState?.userRole?.name !== "Manager"
        ? props.data?.status === "Pending" && (
            <div className="mt-6 flex justify-end">
              <Button danger className="mr-3" onClick={props.handleReject}>
                Reject
              </Button>
              <Button type="primary" htmlType="submit" onClick={props.handleOk}>
                Approve
              </Button>
            </div>
          )
        : props.data?.status === "Pending" && (
            <div className="mt-6 flex justify-end">
              <Button danger className="mr-3" onClick={props.handleDelete}>
                Delete
              </Button>
            </div>
          )}
    </Modal>
  );
}

export default ApproveDesignationModal;
